import * as c from '../constants'

const INITIAL_STATE = {
  filtersSettings: {},
  logsReturn: {},
  isLoading: false,
  errors: {}
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case c.FETCH_LOGS:
      return {
        ...state,
        filtersSettings: action.payload.filtersSettings,
        logsReturn: action.payload.logsReturn
      }
    case c.FETCH_LOGS_REQUEST:
      return { ...state, isLoading: true, errors: {} }
    case c.FETCH_LOGS_FAILURE:
      return { ...state, isLoading: false }
    case c.FETCH_LOGS_SUCCESS:
      return { ...state, isLoading: false, errors: {} }
    default:
      break
  }
  return state
}
